class NSSYotpoInstagram extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Yotpo Instagram] Connected.");

    this.addEventListener("pdpUpdate", this.updateContent.bind(this));
  }

  updateContent(e) {
    if (this.debug) console.log("[NSS][Yotpo Instagram] Updating...");
    const variantId = e.detail;
    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`);
    });
    if (this.debug) console.log("[NSS][Yotpo Instagram] variantId:", variantId);
    const contentEls = this.querySelectorAll(`[nss-variant-id="${variantId}"]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.add(`nss-active`);
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className.split(" ").filter(c => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${variantId}`);
  }
}

let elementName = `nss-yotpo-instagram`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSYotpoInstagram);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}